import React, { useEffect, useMemo, useState } from 'react';
import { Button, Descriptions, Form, Input, message, Modal, Select, Spin, Tooltip } from 'antd';
import { TPageManagement, type TServiceSetting, type TObjectAction, TConditionSetting } from 'types/helloKlarity';
import EditService from '../EditService';
import { conditionSaveOrUpdateBatch, deleteKlaritySpecialtyServiceById, exchangePriority, getKlarityServiceList, klarityServiceBatchUpdate, klarityServiceSpecialtyExchange } from 'api/operation/pageManagement';
import cx from 'classnames';
import commonS from 'styles/common.module.less';
import s from './s.module.less';
import useGetSpecialtyList from 'hooks/klarityServiceTemplateOps/useGetSpecialtyList';
import FileUpload from 'components/form/FileUpload';
import ConditionSelect from 'components/form/ConditionSelect';
import { IKlaritySpecialtyForm } from 'types/serviceTemplate';
// import useGetSpecialtyListByPageId from 'hooks/klarityServiceTemplateOps/useGetSpecialtyListByPageId';

type IProps = {
    pageId?: string;
    isLoading: boolean;
    goLiveObj: TPageManagement;
    onSuccess: (obj: TObjectAction) => void;
    onPreview: (list: IKlaritySpecialtyForm[]) => void;
};

const ServiceManagement: React.FC<IProps> = ({
    pageId,
    goLiveObj,
    isLoading,
    onPreview,
    onSuccess,
}) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [item, setItem] = useState<TServiceSetting>();
    const [service, setService] = useState<TServiceSetting[]>([]);
    const [currentIndex, setIndex] = useState<number>(1);
    const [activeIndex, setActiveIndex] = useState(0);
    const [currentSpecialty, setCurrentSpecialty] = useState<string>('');
    const [listData, tableLoading, error, refetch] = useGetSpecialtyList();
    const [tempSpecialty, setTempSpecialty] = useState<string>('');
    const [isShowModal, setIsShowModal] = useState<boolean>(false);
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState<boolean>(false);
    const [serviceInCurrentSpecialty, setServiceInCurrentSpecialty] = useState<TServiceSetting[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
    const [deleteId, setDeleteId] = useState<number>();

    const specialtyList = useMemo(() => {
        return listData.map((e, index) => {
            const { specialtyName } = e;
            const services = service.filter((serviceItem) => serviceItem.specialtyName === specialtyName);
            return {
                ...e,
                index,
                services,
            };
        });
    }, [listData, service]);

    const disableConditionList = useMemo(() => {
        return [];
    }, []);

    const handleEdit = (selectItem: TServiceSetting, index: number) => {
        setItem(selectItem);
        setIndex(index);
        setIsOpen(true);
    };

    const handleSuccess = (obj: TObjectAction) => {
        setIsOpen(false);
        setItem(undefined);
        onSuccess(obj);
    // fetchData();
    };

    const getList = async () => {
        const { data } = await getKlarityServiceList(pageId!);
        setService(data?.data || []);
    };

    const changeActiveTab = (index: number) => {
        setActiveIndex(index);
    };

    const previewList = useMemo(() => {
        // 把service根据specialtyPriority作为key，然后把Service放到相同key的数组中
        const serviceMap = new Map<number, TServiceSetting[]>();
        service.forEach((e) => {
            const key = e.specialtyPriority;
            if (!serviceMap.has(key)) {
                serviceMap.set(key, []);
            }
            serviceMap.get(key)?.push(e);
        });
        const sortedService = Array.from(serviceMap.entries());
        const res = sortedService.reduce((acc, curr) => {
            const specialty = specialtyList.find((n) => n.specialtyName === curr[1][0].specialtyName);
            if (specialty) {
                acc.push(specialty);
            }
            return acc;
        }, [] as IKlaritySpecialtyForm[]);

        // 对数组进行排序前先检查是否有有效的specialtyPriority
        return res
            .filter((e) => e?.services?.[0]?.specialtyPriority != null)
            .sort((a, b) => {
                const priorityA = a.services?.[0]?.specialtyPriority || 0;
                const priorityB = b.services?.[0]?.specialtyPriority || 0;
                return priorityA - priorityB;
            });
    }, [specialtyList, service]);

    useEffect(() => {
        onPreview(previewList);
    }, [previewList]);

    useEffect(() => {
        const specialty =
      (service || []).find(
          (e) =>
              e.specialtyPriority === activeIndex + 1,
      )?.specialtyName || '';

        setCurrentSpecialty(specialty);
        if (specialty) {
            setServiceInCurrentSpecialty(service.filter((e) => e.specialtyName === specialty));
        } else {
            setServiceInCurrentSpecialty([]);
        }
    }, [activeIndex, service, specialtyList]);

    // useEffect(() => {
    //     setService(goLiveObj.services);
    // }, [goLiveObj]);

    useEffect(() => {
        getList();
    }, []);

    const refetchData = () => {
        getList();
        refetch();
    };

    const handleExchange = async ({
        fromSpecialty,
        toSpecialty,
    }: {
        fromSpecialty: string;
        toSpecialty: string;
    }) => {
        try {
            setLoading(true);
            const res = await klarityServiceSpecialtyExchange(fromSpecialty, toSpecialty);
            if (res && !res.error) {
                message.success('Exchange successfully');
                refetchData();
            } else {
                message.error(res.message);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleChangeSpecialty = (val: string) => {
        // specialty priority 在Service的specialtyPriority
        const filterSpecialtyArr = service.filter(
            (e) => e.specialtyName === val,
        );
        const hadSettingSpecialty = filterSpecialtyArr.length > 0;
        const filterSpecialtyPriority =
      filterSpecialtyArr.length > 0
          ? filterSpecialtyArr[0].specialtyPriority
          : -1;
        if (hadSettingSpecialty) {
            message.error('This Specialty placeholder cannot be directly swapped before the Specialty is set.');
            return;
        }
        // case 1: if there is a service under a specialty and the serviceSpecialtyPriority > 4
        if (hadSettingSpecialty && filterSpecialtyPriority > 4) {
            handleExchange({
                fromSpecialty: currentSpecialty,
                toSpecialty: val,
            });
            return;
        }

        // case 2: if there is no serivce under a specialty and then pup up the modal
        if (!hadSettingSpecialty) {
            setTempSpecialty(val);
            setIsShowModal(true);
            // form.setFieldsValue({ items: filterSpecialtyArr });
            return;
        }

        // case 3: if there is a service under a specialty and the serviceSpecialtyPriority <= 4, exchange
        if (hadSettingSpecialty && filterSpecialtyPriority <= 4) {
            Modal.confirm({
                className: s.removeModal,
                title: 'Exchange specialty',
                content: `Do you want to change ${currentSpecialty} to ${val} ?`,
                okText: 'Confirm',
                onOk: () => {
                    handleExchange({
                        fromSpecialty: currentSpecialty,
                        toSpecialty: val,
                    });
                },
            });
        }
    };

    const onCancelModal = () => {
        setIsShowModal(false);
        form.resetFields();
    };

    const getTheLastPriority = () => {
        const lastService = service.sort((a, b) => a.specialtyPriority - b.specialtyPriority)[service.length - 1];
        return lastService?.specialtyPriority || 0;
    };

    const onSave = async () => {
        try {
            setSubmitting(true);
            const formValues = await form.validateFields();
            const params = formValues.items.map((formItem: TServiceSetting, index) => {
                return {
                    // id: formItem.id,
                    // type: 'HOME',
                    pageId,
                    servicePageUrl: formItem.servicePageUrl!.startsWith('http') || formItem.servicePageUrl!.startsWith('https') || formItem.servicePageUrl!.startsWith('/') ? formItem.servicePageUrl! : `https://${formItem.servicePageUrl!}`,
                    title: formItem.title,
                    subtext: formItem.subtext,
                    image: formItem.image,
                    specialtyName: tempSpecialty,
                    specialtyPriority: currentSpecialty ? getTheLastPriority() + 1 : activeIndex + 1,
                    priority: index + 1,
                };
            });

            const res = await klarityServiceBatchUpdate(params);
            if (res && !res.error) {
                message.success('Updated successfully');
                refetchData();
                setIsShowModal(false);
                form.resetFields();
            } else {
                message.error(res.message);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setSubmitting(false);
        }
    };

    const handleDelete = async (id?: number) => {
        if (!id) return;
        try {
            setLoading(true);
            const res = await deleteKlaritySpecialtyServiceById(id);
            if (res && !res.error) {
                message.success('Deleted successfully');
                setShowDeleteModal(false);
                setDeleteId(undefined);
                refetchData();
            } else {
                message.error(res.message);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={s.wrap}>
            <Spin spinning={isLoading || tableLoading || loading}>
                <div className={s.wrapper}>
                    <div className={s.specialtyWrap}>
                        {(new Array(4).fill(null) || []).map((_, index) => {
                            return (
                                <div
                                    className={cx(
                                        s.specialtyItem,
                                        activeIndex === index && s.current,
                                    )}
                                    key={index}
                                    onClick={() => changeActiveTab(index)}
                                >
                                    Specialty {index + 1}
                                </div>
                            );
                        })}
                    </div>
                    <div className={s.selectSpecialtyWrap}>
                        <Select
                            style={{ width: '150px' }}
                            value={currentSpecialty}
                            className={s.selectSpecialty}
                            onChange={(val) => handleChangeSpecialty(val)}
                        >
                            {specialtyList.map((specialtyItem) => {
                                return (
                                    <Select.Option
                                        value={specialtyItem.specialtyName}
                                        key={specialtyItem.id}
                                    >
                                        {specialtyItem.specialtyName}
                                    </Select.Option>
                                );
                            })}
                        </Select>
                    </div>
                    {serviceInCurrentSpecialty?.map((serviceItem: TServiceSetting, index) => (
                        <div className={s.panel} key={index}>
                            <Descriptions
                                title={`Service ${index + 1}`}
                                layout="vertical"
                                extra={
                                    <div className={s.btns}>
                                        <Button
                                            className={s.removeBtn}
                                            type="link"
                                            onClick={() => {
                                                setDeleteId(serviceItem.id);
                                                setShowDeleteModal(true);
                                            }}
                                        >
                                            Remove
                                        </Button>
                                        <Button onClick={() => handleEdit(serviceItem, index)}>
                                            Edit
                                        </Button>
                                    </div>
                                }
                                column={1}
                                size="small"
                                contentStyle={{
                                    marginBottom: '16px',
                                }}
                            >
                                <Descriptions.Item label="Page link">
                                    {serviceItem.servicePageUrl}
                                </Descriptions.Item>
                                <Descriptions.Item label="Title">
                                    {serviceItem.title}
                                </Descriptions.Item>
                                <Descriptions.Item label="Subtext">
                                    {serviceItem.subtext}
                                </Descriptions.Item>
                                <Descriptions.Item label="Image">
                                    {serviceItem.image && (
                                        <img
                                            src={serviceItem.image}
                                            alt={serviceItem.servicePage}
                                            className={s.serviceLogo}
                                        />
                                    )}
                                </Descriptions.Item>
                            </Descriptions>
                        </div>
                    ))}
                </div>
            </Spin>
            {isOpen && (
                <EditService
                    currentIndex={currentIndex}
                    item={item}
                    list={service}
                    onCancel={() => setIsOpen(false)}
                    onSuccess={handleSuccess}
                />
            )}
            <Modal
                title={`Add services for ${tempSpecialty}`}
                className={commonS.modalFixHeightWrap}
                open={isShowModal}
                destroyOnClose
                okText="Save"
                onCancel={onCancelModal}
                width="500px"
                footer={
                    <div>
                        <Button onClick={onCancelModal}>Cancel</Button>
                        <Button loading={submitting} type="primary" onClick={onSave}>
                            Save changes
                        </Button>
                    </div>
                }
            >
                <div className={s.addWrap}>
                    <Form
                        form={form}
                        className={`${commonS.formStyle1} ${s.serviceForm}`}
                        name="serviceForm"
                        autoComplete="off"
                        initialValues={{ items: [{}] }}
                        scrollToFirstError
                        layout="vertical"
                    >
                        <div className={s.formInner}>
                            <Form.List name="items">
                                {(fields, { add, remove }) => (
                                    <>
                                        <div className={s.cardWrap}>
                                            {fields.map((field) => (
                                                <div key={field.key} className={s.card}>
                                                    <h3 className={s.cardTitle}>
                                                        {`Service ${field.name + 1}`}
                                                        {
                                                            fields.length > 1 && (
                                                                <Button className={s.removeBtn} type="link" onClick={() => remove(field.name)}>Remove</Button>
                                                            )
                                                        }
                                                    </h3>
                                                    <div className={s.cardContent}>
                                                        {/* <Form.Item
                                                            className={s.rowItem}
                                                            label="Service name"
                                                            name={[field.name, 'conditionName']}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: 'Service name is required',
                                                                },
                                                            ]}
                                                        >
                                                            <ConditionSelect
                                                                isLabel
                                                                disableValues={disableConditionList}
                                                            />
                                                        </Form.Item> */}
                                                        <Form.Item
                                                            className={s.rowItem}
                                                            label="Page link"
                                                            name={[field.name, 'servicePageUrl']}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: 'Page link is required',
                                                                },
                                                            ]}
                                                        >
                                                            <Input
                                                                placeholder="http://"
                                                                // maxLength={100}
                                                                style={{ width: '100%' }}
                                                            />
                                                        </Form.Item>
                                                        <Form.Item
                                                            className={s.rowItem}
                                                            label="Title"
                                                            name={[field.name, 'title']}
                                                            rules={[
                                                                { required: true, message: 'Title is required' },
                                                            ]}
                                                        >
                                                            <Input maxLength={30} style={{ width: '100%' }} showCount />
                                                        </Form.Item>
                                                        <Form.Item
                                                            className={s.rowItem}
                                                            label="Subtext"
                                                            name={[field.name, 'subtext']}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: 'Subtext is required',
                                                                },
                                                            ]}
                                                        >
                                                            <Input.TextArea
                                                                maxLength={30}
                                                                style={{ width: '100%' }}
                                                                rows={3}
                                                                showCount
                                                                placeholder="A brief description of the condition"
                                                            />
                                                        </Form.Item>
                                                        <Form.Item
                                                            className={s.rowItem}
                                                            label={
                                                                <div className={s.formLabel}>
                                                                    Logo
                                                                    <Tooltip
                                                                        overlayClassName={s.tipCard}
                                                                        overlayInnerStyle={{ padding: '12px' }}
                                                                        title={
                                                                            <div className={s.tipText}>
                                                                                Image should have a transparent background
                                                                                and be sized 118x118 pixels.
                                                                            </div>
                                                                        }
                                                                    >
                                                                        <div className={s.questionMarkIcon} />
                                                                    </Tooltip>
                                                                </div>
                                                            }
                                                            name={[field.name, 'image']}
                                                            rules={[
                                                                { required: true, message: 'Image is required' },
                                                            ]}
                                                        >
                                                            <FileUpload showImage />
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className={s.addServiceWrap}>
                                            <Button type="link" onClick={() => add({})}>Add a service</Button>
                                        </div>
                                    </>
                                )}
                            </Form.List>
                        </div>
                    </Form>
                </div>
            </Modal>
            <Modal
                className={commonS.modalFixHeightWrap}
                title="Delete service"
                open={showDeleteModal}
                onCancel={() => {
                    setShowDeleteModal(false);
                    setDeleteId(undefined);
                }}
                okText="Delete"
                okType="danger"
                confirmLoading={loading}
                onOk={() => handleDelete(deleteId)}
                destroyOnClose
            >
                <div className={s.deleteModal}>
                    <p>Are you sure you want to delete this service?</p>
                </div>
            </Modal>
        </div>
    );
};

export default ServiceManagement;
